import { render, staticRenderFns } from "./SequenceConverter.vue?vue&type=template&id=95b17b10&scoped=true&"
import script from "./SequenceConverter.vue?vue&type=script&lang=js&"
export * from "./SequenceConverter.vue?vue&type=script&lang=js&"
import style0 from "./SequenceConverter.vue?vue&type=style&index=0&id=95b17b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b17b10",
  null
  
)

export default component.exports